'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhonelinkSetup = function MdPhonelinkSetup(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 1.6c1.8 0 3.4 1.6 3.4 3.4v30c0 1.8-1.6 3.4-3.4 3.4h-16.6c-1.8 0-3.4-1.6-3.4-3.4v-5h3.4v3.4h16.6v-26.8h-16.6v3.4h-3.4v-5c0-1.8 1.6-3.4 3.4-3.4h16.6z m-18.2 21.8c1.8 0 3.2-1.6 3.2-3.4s-1.4-3.4-3.2-3.4-3.4 1.6-3.4 3.4 1.6 3.4 3.4 3.4z m6.3-2.5l1.8 1.4c0.1 0.2 0.3 0.4 0.1 0.5l-1.6 2.9c-0.2 0.2-0.3 0.2-0.5 0.2l-2.2-0.9c-0.4 0.3-1 0.7-1.4 0.9l-0.4 2.1c-0.2 0.1-0.3 0.4-0.5 0.4h-3.4c-0.1 0-0.4-0.3-0.3-0.4l-0.3-2.1c-0.5-0.2-1-0.6-1.5-0.9l-2.3 0.7c-0.2 0.2-0.4-0.1-0.6-0.2l-1.6-2.8c0-0.2 0-0.4 0.2-0.7l1.8-1.3v-1.7l-1.8-1.3c-0.2-0.2-0.4-0.4-0.2-0.5l1.6-2.9c0.2-0.2 0.4-0.2 0.6-0.2l2.1 0.9c0.5-0.3 1.1-0.7 1.6-0.9l0.3-2.1c0.1-0.1 0.3-0.4 0.4-0.4h3.4c0.3 0 0.5 0.3 0.5 0.4l0.4 2.1c0.4 0.2 1 0.6 1.4 0.9l2.2-0.7c0.2-0.2 0.3 0.1 0.5 0.2l1.6 2.8c0 0.2 0 0.4-0.1 0.5l-1.8 1.3v1.8z' })
        )
    );
};

exports.default = MdPhonelinkSetup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/phonelink-setup.js
// module id = 3403
// module chunks = 0